import 'normalize.css';
import 'antd/dist/antd.css';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { getServicesHealth } from 'store/ducks/health.js';

import Menu from 'components/Menu/Menu.js';
import Dashboard from 'components/Dashboard/Dashboard.js';
import Logs from 'components/Logs/Logs.js';
import Servers from 'components/Servers/Servers.js';
import Forms from 'components/Forms/Forms.js';
import Form from 'components/Form/Form.js';
import Users from 'components/Users/Users.js';
import User from 'components/User/User.js';
import Login from 'components/Login/Login.js';
import Trials from 'components/Trials/Trials.js';
import Statistics from 'components/Statistics/Statistics.js';
import Scam from 'components/Scam/Scam.js';
import CustomCode from 'components/CustomCode/CustomCode.js';
import Templates from 'components/Templates/Templates.js';
import Changelog from 'components/Changelog/Changelog.js';
import Invoices from 'components/Invoices/Invoices.js';

import { Layout } from 'antd';

const { Content } = Layout;

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getServicesHealth());
  }, []);

  const loggedIn = localStorage.getItem('user_token');

  return (
    <Router>
      {!loggedIn && <Login />}

      {loggedIn && (
        <Layout style={{ minHeight: '100vh' }}>
          <Route path="/:page?/:id?" exact component={Menu} />

          <Layout>
            <Content style={{ margin: '30px 30px' }}>
              <Switch>
                <Route path="/" exact component={Dashboard} />
                <Route path="/logs" exact component={Logs} />
                <Route path="/servers" exact component={Servers} />
                <Route path="/forms" exact component={Forms} />
                <Route path="/forms/:id" exact component={Form} />
                <Route path="/users" exact component={Users} />
                <Route path="/users/:id" exact component={User} />
                <Route path="/statistics" exact component={Statistics} />
                <Route path="/scam" exact component={Scam} />
                <Route path="/customCode" exact component={CustomCode} />
                <Route path="/templates" exact component={Templates} />
                <Route path="/changelog" exact component={Changelog} />
                <Route path="/invoices" exact component={Invoices} />
                <Route path="/trials" exact component={Trials} />
              </Switch>
            </Content>
          </Layout>
        </Layout>
      )}
    </Router>
  );
};

export default App;
